import { Bill } from "@hagerty/self-service-components/types/providerResponses/shared";
import {
  Customer,
  FeatureFlags,
  DriversClub,
  InsuranceWithBilling,
  Alerts,
} from ".";

export type Persona = {
  /** Unique key used for DevTools */
  key: string;
  description: string;
  customer: Customer;
  alerts: Alerts;
  contactId: string;
  bills: Bill[];
  insuranceWithBilling: InsuranceWithBilling;
  hdc: DriversClub;
  featureFlags: Partial<FeatureFlags>;
};

const hdcBill: Bill = {
  productId: "1",
  productType: "HDC1DOT5",
  OrderId: "1",
  autoPayDetails: null,
  formattedPrice: "$5,000",
  upcomingPaymentDetails: {
    amount: 5000,
    currency: "USD" as any,
    date: "2021-05-01",
    paymentUrl: "",
    informAboutPastDue: true,
    isPastDue: true,
  },
  productDetails: [
    {
      detailType: "Membership Level",
      detailInfo: "1st gear",
    },
  ],
};

export const bills: Bill[] = [
  hdcBill,
  {
    productId: "2",
    productType: "INSURANCE",
    OrderId: "2",
    formattedPrice: "$5,000",
    autoPayDetails: {
      nextChargeAmount: 5000,
      nextChargeDate: "2021-05-01",
      viewDetailsUrl: "",
      paymentMethodDetails: {
        last4: "1234",
      },
      informAboutFailure: false,
      isFailed: false,
    },
    upcomingPaymentDetails: {
      amount: 150000,
      currency: "USD" as any,
      date: "2021-05-01",
      paymentUrl: "",
      informAboutPastDue: false,
      isPastDue: false,
    },
    productDetails: [
      {
        detailInfo: "1956 Porsche Cayenne",
        detailType: "Vehicle",
      },
      {
        detailInfo: "1944 Ford Model T",
        detailType: "Vehicle",
      },
    ],
  },
  {
    productId: "3",
    productType: "INSURANCE",
    OrderId: "3",
    formattedPrice: "$5,000",
    autoPayDetails: {
      nextChargeAmount: 5000,
      nextChargeDate: "2021-05-01",
      viewDetailsUrl: "",
      paymentMethodDetails: {
        last4: "1234",
      },
      informAboutFailure: false,
      isFailed: false,
    },
    upcomingPaymentDetails: {
      amount: 150000,
      currency: "USD" as any,
      date: "2021-05-01",
      paymentUrl: "",
      informAboutPastDue: false,
      isPastDue: false,
    },
    productDetails: [
      {
        detailInfo: "1956 Porsche Cayenne",
        detailType: "Vehicle",
      },
      {
        detailInfo: "1944 Ford Model T",
        detailType: "Vehicle",
      },
    ],
    isSubmitted: true,
  },
];

const jayLeno: Persona = {
  key: "jayLeno",
  description:
    "🇺🇸 | Multiple policies, one with broker | HDC 1.5 3rd Gear | All alerts",
  customer: {
    email: "jay@leno.com",
    firstName: "Jay",
    middleName: "",
    lastName: "Leno",
    line1: "1149 Tower Road",
    line2: "",
    city: "Beverly Hills",
    state: "CA",
    postalCode: "90210",
    country: "USA",
    phone: "3025551212",
  },
  alerts: {
    hdcAutopayFailed: true,
    hdcBillPastDue: true,
    insuranceAutopayFailed: [
      {
        policyNumber: "abc123",
        state: "MD",
        country: "USA",
      },
    ],
    insuranceBillPastDue: [
      {
        policyNumber: "def456",
        state: "MD",
      },
    ],
    eSignDocuments: [
      {
        id: 1,
        source: "usa",
        state: "MD",
      },
    ],
  },
  contactId: "JAY123",
  bills,
  insuranceWithBilling: {
    billing: { status: "success", amount: 123, dueDateISO: "2021-01-31" },
    policies: [
      {
        hasIdCard: true,
        policyNumber: "abc123",
        effectiveDate: "2025-12-25",
        expirationDate: "2026-11-30",
        premium: 5000,
        state: "MD",
        country: "USA",
        broker: {
          name: "Mr Broker Man",
          phone: "3015551212",
          line1: "1000 Broker Ln",
          line2: "",
          city: "Baltimore",
          state: "MD",
          postalCode: "03456",
          email: "brokerman@example.com",
        },
        vehicles: [
          {
            id: "100",
            year: 1965,
            make: "Shelby",
            model: "Cobra 427",
            value: 1000000,
            policyItemNumber: 1,
          },
          {
            id: "101",
            year: 1968,
            make: "Dodge",
            model: "Super Bee",
            value: 65000,
            policyItemNumber: 2,
          },
        ],
      },
      {
        hasIdCard: true,
        policyNumber: "def456",
        effectiveDate: "2025-03-01",
        expirationDate: "2026-04-19",
        premium: 15000,
        state: "MD",
        country: "USA",
        vehicles: [
          {
            id: "200",
            year: 1962,
            make: "Ferrari",
            model: "250 GTO",
            value: 48400000,
            policyItemNumber: 1,
          },
        ],
      },
    ],
  },
  hdc: {
    hdcVersion: "1.5",
    membershipId: "HDC01981376",
    effectiveDate: "2020-01-20",
    expirationDate: "2021-01-20",
    benefits: { distance: 150, coversAllVehicles: true },
    membershipLevel: "3",
  },
  featureFlags: {},
};

const barackTrudeau: Persona = {
  key: "barackTrudeau",
  description:
    "🇺🇸/🇨🇦 | Multiple policies, one with broker | HDC 1.5 VIP | Insurance Autopay failed and HDC Autopay failed",
  customer: {
    email: "barack@trudeau.com",
    firstName: "Barack",
    middleName: "",
    lastName: "Trudeau",
    line1: "1600 Pennsylvania Ave",
    line2: "",
    city: "Washington",
    state: "DC",
    postalCode: "01000",
    country: "USA",
    phone: "2023591000",
  },
  alerts: {
    hdcAutopayFailed: true,
    insuranceAutopayFailed: [
      {
        policyNumber: "def456",
        state: "ON",
        country: "CANADA",
      },
    ],
  },
  contactId: "BARACK1",
  bills,
  insuranceWithBilling: {
    billing: { status: "success", amount: 456, dueDateISO: "2021-01-31" },
    policies: [
      {
        hasIdCard: true,
        policyNumber: "abc123",
        effectiveDate: "2025-12-25",
        expirationDate: "2026-11-30",
        premium: 5000,
        state: "DC",
        country: "USA",
        partner: "state-farm",
        broker: {
          name: "Mr Broker Man",
          phone: "3015551212",
          line1: "1000 Broker Ln",
          line2: "",
          city: "Baltimore",
          state: "MD",
          postalCode: "03456",
          email: "brokerman@example.com",
        },
        vehicles: [
          {
            id: "100",
            year: 1965,
            make: "Shelby",
            model: "Cobra 427",
            value: 1000000,
            policyItemNumber: 1,
          },
          {
            id: "101",
            year: 1968,
            make: "Dodge",
            model: "Super Bee",
            value: 65000,
            policyItemNumber: 2,
          },
        ],
      },
      {
        hasIdCard: true,
        policyNumber: "def456",
        effectiveDate: "2025-03-01",
        expirationDate: "2026-04-19",
        premium: 15000,
        state: "ON",
        country: "CANADA",
        vehicles: [
          {
            id: "200",
            year: 1962,
            make: "Ferrari",
            model: "250 GTO",
            value: 48400000,
            policyItemNumber: 1,
          },
        ],
      },
    ],
  },
  hdc: {
    hdcVersion: "1.5",
    membershipId: "HDC01981371",
    effectiveDate: "2020-01-20",
    expirationDate: undefined,
    benefits: { distance: 150, coversAllVehicles: true },
    membershipLevel: "VIP",
  },
  featureFlags: {},
};

const janeDoe: Persona = {
  key: "janeDoe",
  description: "🇺🇸 | No policies | HDC 1.0 1st Gear | HDC Autopay failed",
  customer: {
    email: "jane@doe.com",
    firstName: "Jane",
    middleName: "Marie",
    lastName: "Doe",
    line1: "100 S. Main St",
    line2: "Apt 2B",
    city: "Motor City",
    state: "MI",
    postalCode: "40001-1234",
    country: "USA",
    phone: "2025551212",
  },
  alerts: {
    hdcAutopayFailed: true,
  },
  contactId: "JANE123",
  bills: [],
  insuranceWithBilling: {
    billing: { status: "success", amount: 0, dueDateISO: "2021-01-31" },
    policies: [],
  },
  hdc: {
    hdcVersion: "1.0",
    membershipId: "HDC04534125",
    expirationDate: "2022-04-27",
    effectiveDate: "2021-01-20",
    benefits: { distance: 20, coversAllVehicles: false },
    membershipLevel: "1",
  },
  featureFlags: {},
};

const dukeCaboom: Persona = {
  key: "dukeCaboom",
  description:
    "🇨🇦 | Single policy with no broker | HDC 1.0 VIP | Bill past due",
  customer: {
    email: "duke@caboom.com",
    firstName: "Duke",
    middleName: "",
    lastName: "Caboom",
    line1: "54 Erie Dr",
    line2: "",
    city: "Montreal",
    state: "QC",
    postalCode: "G1A 0A6",
    country: "CANADA",
    phone: "5145551212",
  },
  alerts: {
    insuranceBillPastDue: [
      {
        policyNumber: "dc101",
        state: "QC",
      },
    ],
  },
  contactId: "DUKE123",
  bills,
  insuranceWithBilling: {
    billing: { status: "unavailable" },
    policies: [
      {
        hasIdCard: true,
        policyNumber: "dc101",
        effectiveDate: "2021-12-25",
        expirationDate: "2022-11-30",
        premium: 51,
        state: "QC",
        country: "CANADA",
        vehicles: [
          {
            id: "100",
            year: 1936,
            make: "Indian",
            model: "Sport Scout Racer",
            value: 31250,
            policyItemNumber: 1,
          },
        ],
        broker: {
          name: "Olde Insurance",
          phone: "5145551313",
          line1: "123 Main St",
          line2: "Suite 201",
          city: "Montreal",
          state: "QC",
          postalCode: "G1A 0A6",
        },
      },
    ],
  },
  hdc: {
    hdcVersion: "1.0",
    membershipId: "HDC08923787",
    expirationDate: undefined,
    effectiveDate: "2022-06-20",
    benefits: { distance: 200, coversAllVehicles: true },
    membershipLevel: "VIP",
  },
  featureFlags: {},
};

const jonHomeless: Persona = {
  key: "jonHomeless",
  description:
    "🇨🇦 | No address or phone | Multiple policies with a broker/billing error | No HDC | 2 E-sign Alerts",
  customer: {
    email: "jon@homeless.com",
    firstName: "Jon",
    middleName: "",
    lastName: "Homeless",
    line1: "",
    line2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "CANADA",
    phone: "",
  },
  alerts: {
    eSignDocuments: [
      { id: 1, source: "usa", state: "MD" },
      { id: 2, source: "canada", state: "QC" },
    ],
  },
  contactId: "JON123",
  bills,
  insuranceWithBilling: {
    billing: { status: "unavailable" },
    policies: [
      {
        hasIdCard: true,
        policyNumber: "abc123",
        effectiveDate: "2025-12-25",
        expirationDate: "2026-11-30",
        premium: 5000,
        state: "MD",
        country: "USA",
        broker: {
          name: "Mr Broker Man",
          phone: "3015551212",
          line1: "1000 Broker Ln",
          line2: "",
          city: "Baltimore",
          state: "MD",
          postalCode: "03456",
          email: "brokerman@example.com",
        },
        vehicles: [
          {
            id: "100",
            year: 1965,
            make: "Shelby",
            model: "Cobra 427",
            value: 1000000,
            policyItemNumber: 1,
          },
        ],
      },
      {
        hasIdCard: true,
        policyNumber: "dc101",
        effectiveDate: "2021-12-25",
        expirationDate: "2022-11-30",
        premium: 51,
        state: "QC",
        country: "CANADA",
        vehicles: [
          {
            id: "100",
            year: 1936,
            make: "Indian",
            model: "Sport Scout Racer",
            value: 31250,
            policyItemNumber: 2,
          },
        ],
        broker: {
          name: "Olde Insurance",
          phone: "5145551313",
          line1: "123 Main St",
          line2: "Suite 201",
          city: "Montreal",
          state: "QC",
          postalCode: "G1A 0A6",
        },
      },
    ],
  },
  hdc: null,
  featureFlags: {},
};

const markNobroker: Persona = {
  key: "markNobroker",
  description:
    "🇨🇦 | Multiple policies with no broker | HDC 1.0 AAA | ESign alert",
  customer: {
    email: "mark@nobroker.com",
    firstName: "Mark",
    middleName: "",
    lastName: "Nobroker",
    line1: "54 Erie Dr",
    line2: "",
    city: "Montreal",
    state: "QC",
    postalCode: "G1A 0A6",
    country: "CANADA",
    phone: "5145551212",
  },
  alerts: {
    eSignDocuments: [{ id: 1, source: "canada", state: "QC" }],
  },
  contactId: "MARK123",
  bills,
  insuranceWithBilling: {
    billing: { status: "unavailable" },
    policies: [
      {
        hasIdCard: false,
        policyNumber: "dc101",
        effectiveDate: "2021-12-25",
        expirationDate: "2022-11-30",
        premium: 51,
        state: "QC",
        country: "CANADA",
        vehicles: [
          {
            id: "100",
            year: 1936,
            make: "Indian",
            model: "Sport Scout Racer",
            value: 31250,
            policyItemNumber: 1,
          },
        ],
      },
      {
        hasIdCard: true,
        policyNumber: "def456",
        effectiveDate: "2025-03-01",
        expirationDate: "2026-04-19",
        premium: 15000,
        state: "QC",
        country: "CANADA",
        vehicles: [
          {
            id: "200",
            year: 1962,
            make: "Ferrari",
            model: "250 GTO",
            value: 48400000,
            policyItemNumber: 1,
          },
        ],
      },
    ],
  },
  hdc: {
    hdcVersion: "1.0",
    membershipId: "HDC08923789",
    expirationDate: "2022-10-31",
    effectiveDate: "2021-10-31",
    benefits: undefined,
    membershipLevel: "AAA",
  },
  featureFlags: {},
};

const tomNoPolicies: Persona = {
  key: "tomNoPolicies",
  description: "🇨🇦 | No policies | No HDC | No alerts",
  customer: {
    email: "tom@nopolicies.com",
    firstName: "Tom",
    middleName: "",
    lastName: "NoPolicies",
    line1: "54 Erie Dr",
    line2: "",
    city: "Montreal",
    state: "QC",
    postalCode: "G1A 0A6",
    country: "CANADA",
    phone: "5145551212",
  },
  alerts: {},
  contactId: "TOM123",
  bills: [hdcBill],
  insuranceWithBilling: {
    billing: { status: "unavailable" },
    policies: [],
  },
  hdc: null,
  featureFlags: {},
};

export const personas = {
  jayLeno,
  janeDoe,
  dukeCaboom,
  jonHomeless,
  markNobroker,
  tomNoPolicies,
  barackTrudeau,
};

export type PersonaKey = keyof typeof personas;
export type Personas = { [key in PersonaKey]: Persona };
